<template>
  <div class="review-content">
    <h3 class="text-lg font-medium text-gray-900 mb-2">
      {{ displayTitle }}
    </h3>
    <div
      v-if="text"
      :class="['text-gray-600', { 'scrollable-text': !lineClamp, 'line-clamp-3': lineClamp }]"
    >
      {{ text || "No content provided." }}
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  title: {
    type: [String, Number],
    required: true,
    default: ''
  },
  text: {
    type: String,
    required: true,
    default: ''
  },
  lineClamp: {
    type: Boolean,
    default: false
  }
})

// Ensure title is always displayed as a string
const displayTitle = computed(() => {
  if (props.title === null || props.title === undefined) {
    return 'Untitled Review'
  }
  return String(props.title) || 'Untitled Review'
})
</script>

<style scoped>
.review-content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
.line-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.scrollable-text {
  max-height: 120px;
  overflow-y: auto;
  padding-right: 4px;
  line-height: 1.5;
}

.scrollable-text::-webkit-scrollbar {
  width: 6px;
}

.scrollable-text::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.scrollable-text::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 10px;
}

.scrollable-text::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
